// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"134":"perfis","234":"Feriados","264":"tiposderefeicoes","327":"configuracoes","404":"usuarios","890":"refeicoes"}[chunkId] + "." + {"134":"fb744d76","234":"017a52ce","264":"457334d1","327":"457334d1","404":"457334d1","890":"457334d1"}[chunkId] + ".css";
};